import { render, staticRenderFns } from "./LayoutWithoutResize.vue?vue&type=template&id=1b48b291&scoped=true"
import script from "./LayoutWithoutResize.vue?vue&type=script&lang=ts"
export * from "./LayoutWithoutResize.vue?vue&type=script&lang=ts"
import style0 from "./LayoutWithoutResize.vue?vue&type=style&index=0&id=1b48b291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48b291",
  null
  
)

export default component.exports